import { isPlatformServer } from "@angular/common";
import { Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, signal, ViewChild } from '@angular/core';
import {
  WagtailCMSCardsPageRendererInterface,
  WagtailCMSCardsRendererInterface,
  WagtailPageContentElementInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-cmscards',
    templateUrl: './shop-cmscards.component.html',
    styleUrls: ['./shop-cmscards.component.scss'],
    standalone: false
})
export class WagtailCMSCardsComponent implements OnInit {

  @Input() definition?: WagtailPageContentElementInterface<WagtailCMSCardsRendererInterface>

  title?: string
  pages?: WagtailCMSCardsPageRendererInterface[]

  @ViewChild('scroller', { read: ElementRef }) set ic(el: ElementRef<HTMLDivElement>) {
    if (isPlatformServer(this.platformId) || ! el) return
    const itemEl = el.nativeElement.querySelector('.item')
    if (! itemEl) return
    const clientWidth = itemEl?.clientWidth
    const width = clientWidth ? clientWidth : 100
    let style = window.getComputedStyle(itemEl)
    const marginX = parseInt(style.marginRight) + parseInt(style.marginLeft)
    this.scrollStep = width + marginX
    this.scrollWidth = el.nativeElement.clientWidth
    this.scroller = el
    if (this.pages) this.totalWidth = this.pages.length * this.scrollStep
    el.nativeElement.addEventListener('scroll', (e) => {
      this.scrollLeft.set((e.target as HTMLDivElement).scrollLeft)
    })
  }

  scroller?: ElementRef<HTMLDivElement>

  scrollStep: number = 100
  // scroll position is written from a native scroll listener (outside Angular) -> signal
  scrollLeft = signal<number>(0)
  scrollWidth: number = 100
  totalWidth: number = 100

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {
  }

  ngOnInit(): void {
    if (this.definition) {
      this.title = this.definition.value.title
      this.pages = this.definition.value.pages
    }
  }

  navNext() {
    this.scroller?.nativeElement.scrollBy(this.scrollStep,0)
  }

  navPrev() {
    this.scroller?.nativeElement.scrollBy(-this.scrollStep,0)
  }
}
